import React from 'react';
import { useOrder } from '../../context/OrderContext';
import { getValidGlassSizes, formatGlassDisplay, normalizeProfileType } from '../../utils/formatters';

const GlassSelector = ({ onSelect, selectedSize }) => {
    const { state } = useOrder();
    const profileType = normalizeProfileType(state.orderDetails.profileType);
    const validSizes = getValidGlassSizes(profileType);

    return (
        <div className="space-y-4">
            <h3 className="text-lg font-medium mb-4">Seleziona dimensione vetro</h3>

            <div className="grid grid-cols-3 gap-4">
                {validSizes.map((size) => (
                    <button
                        key={size}
                        onClick={() => onSelect({ glassSize: size })}
                        className={`p-4 rounded-lg border-2 transition-all ${selectedSize === size
                            ? 'border-red-500 bg-red-50'
                            : 'border-gray-200'
                            }`}
                    >
                        <div className="text-center">
                            <span className="text-xl font-medium">{formatGlassDisplay(size)}</span>
                        </div>
                    </button>
                ))}
            </div>

            <div className="mt-4 text-sm text-gray-500">
                {profileType && (
                    <p>
                        Dimensioni disponibili per il profilo {profileType}: {validSizes.map(size => formatGlassDisplay(size)).join(', ')}
                    </p>
                )}
            </div>
        </div>
    );
};

export default GlassSelector;
